import { delay, put, takeLatest, select } from 'redux-saga/effects';
import { setTokenRefresh } from '../reducers/UserSlice';

function* handleRefreshTokenTimer() {
    
    yield delay(3_000_000) // delay - 50 min 

    yield put(setTokenRefresh(true));
}

export function* watchRefreshToken() {
    yield takeLatest('START_REFRESH_TIMER', handleRefreshTokenTimer);
}